<template>
  <google-map :center="mapCenter" :zoom="15" :options="mapOpts" class="py-lg-50 py-30">
    <google-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
      <div class="text-center pt-4 pb-4 px-3">
        <p class="xsmall font-weight-heavy" v-html="infoContent.title"></p>
        <p class="xxxsmall" v-html="infoContent.descr"></p>
      </div>
    </google-info-window>

    <google-marker :icon="mapIcon" :position="{lat: 38.064318,lng: 23.746232}" @click="toggleInfoWindow({lat: 38.064318,lng: 23.746232},{title: '<p class=\'mb-2\'>PAPA-PASTRY</p>',descr: 'Λ. ΙΩΝΙΑΣ 104,<br>ΑΧΑΡΝΑΙ - ΑΤΤΙΚΗ,<br>Τ.Κ 136 73', directions: 'https://www.google.com/maps/dir/?api=1&destination=Χαρ.+Τρικούπη+151,+Κηφισιά+145+64', tel: '+30 210 80 72 770'})">
    </google-marker>
  </google-map>
</template>

<script>
  import * as VueGoogleMaps from 'vue2-google-maps/dist/vue-google-maps.js'
  // import gmapCluster from 'vue2-google-maps/dist/components/cluster'

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.MIX_MAP_KEY_LOCAL
    },
    installComponents: false,
  })

  export default {
    components: {
      // gmapCluster,
      googleMap: VueGoogleMaps.Map,
      googleMarker: VueGoogleMaps.Marker,
      googleInfoWindow: VueGoogleMaps.InfoWindow
    },
    data() {
      return {
        mapCenter: {
          lat: 38.064318,
          lng: 23.746232
        },
        mapOpts: {
          styles: [{
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
              "color": "#e9e9e9"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 29
            }, {
              "weight": 0.2
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 18
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 21
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
              "color": "#dedede"
            }, {
              "lightness": 21
            }]
          }, {
            "elementType": "labels.text.stroke",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "elementType": "labels.text.fill",
            "stylers": [{
              "saturation": 36
            }, {
              "color": "#333333"
            }, {
              "lightness": 40
            }]
          }, {
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f2f2f2"
            }, {
              "lightness": 19
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 17
            }, {
              "weight": 1.2
            }]
          }],
          // gestureHandling: "greedy",
          scrollwheel: false
        },
        mapIcon: {
          url: '/public/site/papapastry/dist/images/pin.png',
          // size: {width: 46, height: 46, f: 'px', b: 'px'},
          scaledSize: {
            width: 25,
            height: 27,
            f: 'px',
            b: 'px'
          }
        },
        infoWinOpen: false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -30
          }
        },
        infoContent: {
          title: null,
          descr: null,
          address: null
        },
        infoWindowPos: null,
        currentMidx: null,
        clusterStyles: [{
          textColor: '#fff',
          url: '/public/site/' + process.env.MIX_TEMPLATE_FOLDER + '/dist/img/cluster.png',
          height: 50,
          width: 50
        }]
      }
    },
    methods: {
      toggleInfoWindow: function (position, content, idx) {

        this.infoWindowPos = position;
        this.infoContent = content

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      }
    },
  }
</script>

<style>

</style>